export const TEST_ID = 'organizationSubscriptionDetails';

export const LEARN_MORE_URL = 'https://www.rantizo.com/AcreConnect';

export const UPGRADE_URL = 'https://www.acreconnect.io/product/1-pilot-pay-yearly-new';
